import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA2');

    return (
        <>
            <EcoSpace />
            <img src="https://websiteoss.ecoflow.com/upload/image/1741257663766/1920_light_1.jpg" className="demo-img-full" />
        </>
    );
}
